import openQueryInfo from './open-query-info.action';

export default openQueryInfo;
